import React from "react";
//import { useDispatch, useSelector } from "react-redux";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    DialogActions
} from "@mui/material/";
//import Alert from "@mui/material/Alert";
//import { clearNotification } from "../../redux/slices/notificationSlice";

const ConfirmDialog = ({open, onClose, title, cancelLabel, cancelAction, confirmLabel, confirmAction, children}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <Button className="cancel-btn" onClick={cancelAction} color="primary">
                    {cancelLabel}
                </Button>
                <Button
                    onClick={confirmAction}
                    color="error"
                    variant="contained"
                    className="confirm-btn"
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDialog;
